import { format } from 'date-fns-tz';
import { ptBR } from 'date-fns/locale';
import { isValid } from 'date-fns/esm';

export function toISOLocal(d: Date): string {
  const z = (n: number) => `0${n}`.slice(-2);
  let off = d.getTimezoneOffset();
  const sign = off < 0 ? '+' : '-';
  off = Math.abs(off);

  return `${d.getFullYear()}-${z(d.getMonth() + 1)}-${z(d.getDate())}T${z(
    d.getHours(),
  )}:${z(d.getMinutes())}${sign}${z(off / 60 || 0)}${z(off % 60)}`;
}

export function toISOLocalDate(d: Date): string {
  const z = (n: number) => `0${n}`.slice(-2);
  let off = d.getTimezoneOffset();
  // const sign = off < 0 ? '+' : '-';
  off = Math.abs(off);

  return `${d.getUTCFullYear()}-${z(d.getMonth() + 1)}-${z(d.getDate())}`;
}

export function getSplitDates(d: Date): string[] {
  const date: string[] = [];
  date.push(`${d.getFullYear()}`);
  date.push(`${d.getMonth()}`);
  date.push(`${d.getDate()}`);
  return date;
}

export function toDate(dateString: string, stringMask = 'dd/MM/yyyy HH:mm'): string {
  const dateObj = new Date(toISOLocal(new Date(dateString)));

  if (isValid(dateObj)) {
    const newDate = format(dateObj, stringMask, {
      locale: ptBR,
      timeZone: 'America/Fortaleza',
    });
    return newDate;
  }
  return '';
}

export function dateToBRT(dateObj: Date, fn?: Function): string {
  const formatDate = "yyyy-MM-dd'T'HH:mm:ssXXX";

  if (isValid(dateObj)) {
    return format(fn ? fn(dateObj) : dateObj, formatDate, {
      timeZone: 'America/Sao_Paulo',
    });
  }
  return '';
}

export function dateToBRTDate(dateObj: Date, fn?: Function): Date {
  const dateString = dateToBRT(dateObj, fn);
  return new Date(dateString);
}
